/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryResource extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryResource");
    }

    getFixupPrototypeFunction() { return ScheduleQueryResource.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryResource>): ScheduleQueryResource {
        let obj = Object.assign(new ScheduleQueryResource(), model);
        ScheduleQueryResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryResource>): ScheduleQueryResource {
        if (!model) return null;
        return ScheduleQueryResource.newInstance(<ScheduleQueryResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryResource) {
        if (!obj) return;

        models.ScheduleQueryResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryResource): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource IDs (e.g., Policy IDs) targeted by the Schedule
     */
    resources: Array<string>;

}
